import { Bell, CurrencyDollar, GearSix, Warehouse } from "@phosphor-icons/react";
import { MenuItemType } from "types/menu.types";

export const sidebarItems: MenuItemType = {
  key: "setting",
  label: "Quản Lý Cài Đặt",
  path: "/settings",
  icon: <Warehouse size={20} />,
  children: [],
};

export const sidebarItemsConst: MenuItemType[] = [
  {
    key: "thongBao",
    label: "Thông Báo",
    path: "/notifications",
    icon: <Bell size={16} />,
  },
  {
    key: "caiDat",
    label: "Cài Đặt",
    path: "/general-settings",
    icon: <GearSix size={16} />,
  },
];

export const menuItems: MenuItemType[] = [
  // {
  //   key: "trangchu",
  //   label: "Trang chủ",
  //   path: "/",
  // },
  {
    key: "quanlylenh",
    label: "Quản lý lệnh vận tải",
    path: "/command-list",
    children: [
      {
        key: "chitietlenh",
        label: "Chi tiết lệnh",
        path: "/command-list/detail/:id",
        subMenuDisplay: false,
      },
      {
        key: "taolenh",
        label: "Tạo lệnh",
        path: "/command-list/create",
      },
      {
        key: "danhsachlenh",
        label: "Danh sách lệnh",
        path: "/command-list",
      },
    ],
  },
  {
    key: "finance",
    label: "Quản lý tài chính",
    path: "/finance/payroll",
    icon: <CurrencyDollar size={16} />,
    children: [
      {
        key: "payrollManagement",
        label: "Quản lý lương nhân viên",
        path: "/finance/payroll",
      },
    ],
  },
  {
    key: "settings",
    label: "Thiết lập chung",
    path: "/settings/staff",
    children: [
      {
        key: "staffView",
        label: "Xem thông tin cá nhân",
        path: "/settings/staff/:id",
        subMenuDisplay: false,
      },
      {
        key: "staffAdd",
        label: "Chỉnh sửa thông tin cá nhân",
        path: "/settings/staff/add/:type",
        subMenuDisplay: false,
      },
      {
        key: "staffEdit",
        label: "Chỉnh sửa thông tin cá nhân",
        path: "/settings/staff/edit/:id",
        subMenuDisplay: false,
      },
      {
        key: "staffManagement",
        label: "Quản lý nhân viên",
        path: "/settings/staff",
      },
      {
        key: "customerManagement",
        label: "Quản lý công ty",
        path: "/settings/customers",
        children: [
          {
            key: "customerView",
            label: "Xem thông tin công ty",
            path: "/settings/customers/:id",
            subMenuDisplay: false,
          },
          {
            key: "customerEdit",
            label: "Chỉnh sửa thông tin công ty",
            path: "/settings/customers/edit/:id",
            subMenuDisplay: false,
          },
        ],
      },
      {
        key: "vehicleManagement",
        label: "Quản lý xe",
        path: "/settings/vehicles",
      },
      {
        key: "containerManagement",
        label: "Quản lý container",
        path: "/settings/containers",
        children: [
          {
            key: "containerEdit",
            label: "Chỉnh sửa container",
            path: "/settings/containers/:id",
            subMenuDisplay: false,
          },
        ],
      },
    ],
  }
];
